<template>
    <div class="animated fadeIn grid">
        <div class="kgr-postfix kgr-postfix--gutters kgr-row">
            <div class="kgr-postfix__fixed">
                <input
                    v-model="newSearchPhrase"
                    type="text"
                    class="kgr-input"
                    :placeholder="$t('Suchbegriff')"
                    @keyup.enter="submitNewSearch"
                />
            </div>
            <div class="kgr-postfix__fluid">
                <kgr-btn @click="submitNewSearch()">
                    {{ $t('search') }}
                </kgr-btn>
            </div>
        </div>

        <div
            v-if="results.length === 0"
            class="list-item no-results"
        >
            <kgr-empty :value="$t('Es wurden keine Ergebnisse gefunden.')" />
        </div>

        <div v-else>
            <kgr-result-filter
                :filters="filterStates"
                class="kgr-row"
                @changed="onChangedFilter"
            />

            <kgr-empty
                v-if="filteredResults.length === 0"
                :value="$t('Keine Ergebnisse für die ausgewählten Filter vorhanden.')"
            />

            <div
                v-else
                class="kgr-grid kgr-grid--inlineBlock kgr-grid--gutters"
            >
                <div
                    v-for="result in filteredResults"
                    :key="result.link"
                    class="app-gridCard kgr-grid__cell"
                >
                    <kgr-result
                        :result-data="result"
                        :search-phrase="searchPhrase"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmptyData from '../../common/EmptyData.vue';
import KgrButton from '../../common/form/button/KgrButton.vue';
import LiveSearchResult from './LiveSearchResult.vue';
import LiveSearchResultFilter from './LiveSearchResultFilter.vue';

export default {
    components: {
        'kgr-btn': KgrButton,
        'kgr-empty': EmptyData,
        'kgr-result': LiveSearchResult,
        'kgr-result-filter': LiveSearchResultFilter,
    },
    props: {
        filters: {
            type: Array,
            required: true,
        },
        checkedFilters: {
            type: Array,
            required: true,
        },
        searchPhrase: {
            type: String,
            required: true,
        },
        searchResultPath: {
            type: String,
            required: true,
        },
        results: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            newSearchPhrase: this.searchPhrase,
            filterStates: [],
        }
    },
    computed: {
        filteredResults() {
            const checkedFilters = this.filterStates
                .filter(filter => filter.checked)
                .map(filter => filter.name);

            return this.results.filter(result => checkedFilters.indexOf(result.category) > -1);
        },
    },
    created() {
        const noCheckedFilters = this.checkedFilters.length === 0;

        this.filters.forEach(name => {
            const count = this.results.filter(result => result.category === name).length;
            const checked = noCheckedFilters || this.checkedFilters.indexOf(name) > -1;

            this.filterStates.push({name, count, checked});
        });
    },
    methods: {
        onChangedFilter(name) {
            const newFilterStates = [];
            this.filterStates
                .forEach(filter => {
                    if (filter.name === name) {
                        filter.checked = !filter.checked;
                    }

                    newFilterStates.push(filter);
                });

            this.$set(this.filterStates, newFilterStates);
        },
        submitNewSearch() {
            if ('' === this.newSearchPhrase) {
                return;
            }

            const checkedFiltersString = this.filterStates
                .filter(filter => filter.checked)
                .map(filter => `checkedFilters[]=${filter.name}`)
                .join('&');

            window.location = `${this.searchResultPath}?q=${this.newSearchPhrase}&${checkedFiltersString}`;
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
